import { Box, BoxProps, Text, TextProps } from '@jfs/ui-new'

export const AadhaarNoBanner = ({ aadhaarNo }: { aadhaarNo: string }) => {
  return (
    <Box {...styles.container}>
      <Text {...styles.text}>{`AADHAAR Number : ${aadhaarNo}`}</Text>
    </Box>
  )
}

const styles = {
  container: {
    backgroundColor: 'BRAND_PRIMARY_WHITE',
    alignItems: 'center',
    alignSelf: 'center',
    ph: 16,
    pv: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  } as BoxProps,
  text: {
    color: 'BLACK_21',
    fontSize: 12,
    fontFamily: 'jioType-medium',
    textAlign: 'center',
  } as TextProps,
}
